import { schema } from 'normalizr';

const inspectionSchema = new schema.Entity(
  'inspection',
  {},
  {
    idAttribute: (value, parent, key) => {
      return value.formData._id;
    },
  }
);

const inspectionTypeSchema = new schema.Entity(
  'inspectionType',
  {},
  {
    idAttribute: 'key',
  }
);

const inspectionTypesSchema = new schema.Array(inspectionTypeSchema);

const formDataSchema = new schema.Entity(
  'formData',
  {},
  {
    idAttribute: '_id',
  }
);

const availableFiltersSchema = new schema.Entity(
  'availableFilters',
  {},
  { idAttribute: entity => 'filters' }
);
const inspectionReportSchema = new schema.Entity(
  'inspection',
  {},
  {
    idAttribute: '_id',
    processStrategy: entity => {
      return {
        ...entity,
        formSchema: entity.formId,
        formData: entity._id,
      };
    },
  }
);
const costEstimateSchema = new schema.Entity(
  'costEstimate',
  {
    inspection: inspectionReportSchema,
  },
  {
    idAttribute: '_id',
  }
);
const formSchema = new schema.Entity(
  'formSchema',
  {},
  {
    idAttribute: 'id',
  }
);
const formSchemaSchema = new schema.Entity(
  'formSchemaSchema',
  {},
  {
    idAttribute: 'formId',
  }
);
const formSchemasSchema = new schema.Array(formSchemaSchema);
const costEstimatesSchema = new schema.Array(costEstimateSchema);
const formDataArraySchema = new schema.Array(formDataSchema);
const inspectionsArraySchema = new schema.Array(inspectionReportSchema);
const inspectionsSchema = new schema.Entity('inspections', {
  inspections: inspectionsArraySchema,
  availableFilters: availableFiltersSchema,
});

inspectionSchema.define({
  formSchema: formSchema,
  formData: formDataSchema,
});

const userSchema = new schema.Entity('user', {}, { idAttribute: '_id' });
const usersSchema = new schema.Array(userSchema);

const authResponseSchema = new schema.Values(
  {
    user: userSchema,
  },
  (input, parent, key) => {
    return `${key}`;
  }
);

/*
inspectionTypeSchema.define({
  brand: availableBrandSchema,
});
*/
export default {
  authResponseSchema,
  formSchemasSchema,
  formDataArraySchema,
  inspectionSchema,
  inspectionsSchema,
  inspectionTypeSchema,
  inspectionTypesSchema,
  costEstimateSchema,
  costEstimatesSchema,
  userSchema,
  usersSchema,
};



// WEBPACK FOOTER //
// ./src/api/schema.js